module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/girl-smiling-pink-jacket/girl-smiling-pink-jacket@2x.png"